import { jsx as e } from "@emotion/react/jsx-runtime";
import { IconButton as s, FontAwesomeIconsPartooUsed as n, IconPrefix as r, Icon as d } from "@partoohub/ui";
import { StyledIconContainer as m, StyledIconWrapper as I } from "./ConditionalResetIcon.styled.js";
const y = ({
  dataTrackId: o,
  onReset: t,
  iconSize: i = "12px",
  caretIcon: a = [n.faChevronRight, r.SOLID],
  showReset: c = !1,
  applyDefaultColor: l = !1
}) => /* @__PURE__ */ e(m, { applyDefaultColor: l, children: c ? /* @__PURE__ */ e(s, { onClick: t, icon: [n.faCircleXmark, r.SOLID], appearance: "outlined", dataTrackId: `${o}__reset`, "aria-label": `${o}__reset`, size: "small", variant: "secondary" }) : /* @__PURE__ */ e(I, { direction: "row", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ e(d, { icon: a, color: "secondary", iconSize: i }) }) });
export {
  y as ConditionalResetIcon
};
